import TableViewAllFilterTags from './tableViewAllFilterTags';

export default TableViewAllFilterTags;
